<tlk-card>
	<span tlkCardHeader>{{ procedureTitle$ | async }}:</span>
	<div tlkCardContent>
		<div class="intuitive-card-content">
			<ng-container *ngIf="applianceFieldsVisibility$ | async as fieldsVisibility">
				<rx-procedure-type-control
					*ngIf="fieldsVisibility.procedureType"
					[styles]="{ flex: '1', 'min-width': '240px', 'max-width': '40%' }"
					[id]="'type'"
				></rx-procedure-type-control>

				<ng-container *ngIf="fieldsVisibility.applianceType || fieldsVisibility.upperLowerCard">
					<rx-select
						class="intuitive-inline-controls"
						*ngIf="fieldsVisibility.applianceType"
						[id]="'applianceType'"
						[label]="'ApplianceDetails.ApplianceType' | translate"
						[formControl]="applianceTypeControl"
						[options]="applianceTypes$ | async"
						[isDisabled]="isReadOnly$ | async"
						[isCancellable]="true"
						name="applianceTypeControl"
					>
					</rx-select>

					<!-- Arch Toggles -->
					<ng-container *ngIf="fieldsVisibility.upperLowerCard">
						<div class="arch-toggles">
							<div class="arch-label">
								<small>{{ 'ApplianceDetails.ArchToTreat' | translate }}</small>
							</div>
							<div class="toggles-row">
								<tlk-slide-toggle
									class="toggle"
									[formControl]="isUpperControl"
									[id]="'isUpper'"
									name="isUpperControl"
									labelPosition="left"
									[isDisabled]="(isApplianceUpperReadonly$ | async) || (isReadOnly$ | async)"
									(disableChangeEvent)="switchOffControl($event, isUpperControl)"
								>
									{{ 'ApplianceDetails.UpperArchLabel' | translate }}
								</tlk-slide-toggle>

								<tlk-slide-toggle
									class="toggle"
									[formControl]="isLowerControl"
									[id]="'isLower'"
									name="isLowerControl"
									labelPosition="left"
									[isDisabled]="(isApplianceLowerReadonly$ | async) || (isReadOnly$ | async)"
									(disableChangeEvent)="switchOffControl($event, isLowerControl)"
								>
									{{ 'ApplianceDetails.LowerArchLabel' | translate }}
								</tlk-slide-toggle>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</ng-container>
		</div>
	</div>
</tlk-card>
